import { Box, Typography, Button } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';

interface MaintProps {
  func: (params: {yes?: boolean, no?: boolean}) => Promise<void>
}

export function MajorMaintWarning({
    func
}: MaintProps) {

  return <>
    <Box
        sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1300,
        }}
        >
            <Box
            sx={{
                backgroundColor: 'rgba(14, 70, 63, 1)',
                border: '2px solid #7BBCB3',
                borderRadius: '12px',
                maxWidth: '600px',
                width: '90%',
                px: { xs: 3, sm: 4 },
                py: { xs: 4, sm: 5 },
                textAlign: 'center',
                color: '#fff',
            }}
            >
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                <InfoOutlinedIcon sx={{ fontSize: 40, color: '#fff' }} />
            </Box>

            <Typography
                variant="h6"
                sx={{
                fontWeight: 600,
                mb: 2,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                }}
            >
                Your Maintenance Cycle Has Changed
            </Typography>

            <Typography
                variant="body1"
                sx={{
                mb: 4,
                opacity: 0.9,
                }}
            >
                Do you wish to update your annual operating costs at this time?
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                <Button
                variant="contained"
                onClick={(_e: React.MouseEvent<HTMLButtonElement>) => func({yes: true})}
                sx={{
                    backgroundColor: '#E0E0E0',
                    color: '#000',
                    borderRadius: '20px',
                    px: 4,
                    '&:hover': {
                    backgroundColor: '#d5d5d5',
                    },
                }}
                >
                Yes
                </Button>

                <Button
                variant="outlined"
                onClick={(_e: React.MouseEvent<HTMLButtonElement>) => func({no: true})}
                sx={{
                    color: '#fff',
                    borderColor: '#fff',
                    borderRadius: '20px',
                    px: 4,
                    '&:hover': {
                    borderColor: '#ccc',
                    },
                }}
                >
                No
                </Button>
            </Box>
            </Box>
        </Box>
  </>;
}
